import { type CombinedMobileSidebarBox, type SidebarBoxConfig } from 'AdmissionsGuidance';
import { memo, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { isCombinedMobileSidebarBox } from '../StudentDashboardSidebarTypeGuards';

type Props = {
    colorClassname: string;
    boxConfig: SidebarBoxConfig | CombinedMobileSidebarBox;
};

function MobileSidebarBoxComponent({ colorClassname, boxConfig }: Props) {
    const mobileContent = useMemo(
        () => (isCombinedMobileSidebarBox(boxConfig) ? boxConfig.primary.mobileContent : boxConfig.mobileContent),
        [boxConfig],
    );

    if (!mobileContent) {
        return null;
    }

    return (
        <div className={twMerge(colorClassname, 'h-[45px] w-full transition-[height] duration-300 sm:h-[65px]')}>
            {mobileContent}
        </div>
    );
}

export const MobileSidebarBox = memo(MobileSidebarBoxComponent) as typeof MobileSidebarBoxComponent;
